// Validação e sugestão de e-mail no cadastro (estilo mailcheck). Formato puro não
// pega typo como "bernisoftware.copm.br" (é sintaticamente válido), então sugerimos
// a correção provável — o usuário aplica com 1 clique.

// Formato básico (não exaustivo de propósito; o servidor é a verdade final).
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
}

// Provedores comuns p/ sugerir correção por distância de edição.
const COMMON_DOMAINS = [
  'gmail.com', 'googlemail.com', 'hotmail.com', 'outlook.com', 'live.com',
  'yahoo.com', 'yahoo.com.br', 'icloud.com', 'me.com', 'msn.com', 'proton.me',
  'hotmail.com.br', 'outlook.com.br', 'uol.com.br', 'bol.com.br',
  'terra.com.br', 'globo.com', 'ig.com.br',
];

// Labels que são quase-certamente "com" digitado errado (e NÃO são TLDs válidos,
// p/ não sugerir besteira em domínios legítimos como ".co" ou ".cm").
const COM_TYPOS = new Set(['con', 'cmo', 'copm', 'comm', 'cpm', 'ocm', 'vom', 'xom', 'cob', 'coam', 'comr', 'cnm']);

function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  if (!m) return n;
  if (!n) return m;
  let prev = Array.from({ length: n + 1 }, (_, i) => i);
  let curr = new Array<number>(n + 1);
  for (let i = 1; i <= m; i++) {
    curr[0] = i;
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
    }
    [prev, curr] = [curr, prev];
  }
  return prev[n];
}

// Devolve um e-mail corrigido provável, ou null se nada a sugerir.
export function suggestEmail(raw: string): string | null {
  const email = raw.trim().toLowerCase();
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (!domain.includes('.') || /\s/.test(domain)) return null;

  // 1) Corrige um label que é typo claro de "com" (ex.: ...copm.br -> ...com.br).
  const labels = domain.split('.');
  let changed = false;
  const fixed = labels.map((l) => (COM_TYPOS.has(l) ? ((changed = true), 'com') : l));
  if (changed) {
    const out = `${local}@${fixed.join('.')}`;
    return out !== email ? out : null;
  }

  // 2) Provedor comum digitado errado (distância de edição <= 2).
  let best: string | null = null;
  let bestDist = 3;
  for (const d of COMMON_DOMAINS) {
    const dist = levenshtein(domain, d);
    if (dist > 0 && dist < bestDist) { bestDist = dist; best = d; }
  }
  if (best && bestDist <= 2) return `${local}@${best}`;

  return null;
}
